import React from 'react';

interface PaginatorProps {
  hasNext: boolean;
  hasPrevious: boolean;
  onNext: () => void;
  onPrevious: () => void;
}

const Paginator: React.FC<PaginatorProps> = ({ hasNext, hasPrevious, onNext, onPrevious }) => {
  return (
    <nav className='flex flex-row flex-grow-0 justify-center gap-8 text-xl mb-8 w-full'>
      {hasPrevious ? (
        <button className='link-blue' onClick={onPrevious}>
          Previous
        </button>
      ) : null}
      {hasNext ? (
        <button className='link-blue' onClick={onNext}>
          Next
        </button>
      ) : null}
    </nav>
  );
};

export default Paginator;
